module.exports = __webpack_public_path__ + "static/media/20170806_30day_1487AT.de687178.jpg";